/* PublicCardPage — "/card/:slug". Public share view of a student's Clarity Card.
   Shows ONLY: name, path, fit band, badges. */
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Sparkles } from 'lucide-react';
import Navbar from '../components/Navbar';
import ClarityCard from '../components/clarity/ClarityCard';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicCardPage() {
  const { slug } = useParams();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/clarity-card/share/${slug}`)
      .then((r) => setCard(r.data))
      .catch(() => setErr('This Career Clarity Card was not found.'));
  }, [slug]);

  const publicCard = card ? {
    slug,
    name: card.name,
    avatar: card.avatar,
    committed_path: card.committed_path,
    fit: card.fit_band ? { title: card.fit_band } : null,
    counts: { stories_lived: card.counts?.stories_lived ?? 0, badges: card.counts?.badges ?? 0, skills_started: 0 },
    badges: card.badges || [],
    stories: { yes: [], maybe: [], no: [] },
    strengths: [],
    life_skills: [],
    progress_pct: card.progress_pct ?? 0,
    paths_touched: [],
    is_empty: false,
  } : null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-white to-teal-50">
      <Navbar />
      <div className="pt-28 pb-20 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-xs font-black uppercase tracking-[0.25em] text-teal-600 mb-2">LearnixTa · Career Clarity Card</p>
          {err && <p className="text-sm text-rose-600 py-16" data-testid="public-card-error">{err}</p>}
          {!card && !err && <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-teal-600" /></div>}
          {publicCard && (
            <>
              <h1 className="text-2xl md:text-3xl font-black text-gray-900 mb-8" data-testid="public-card-title">
                {card.name}&apos;s career journey
              </h1>
              <ClarityCard card={publicCard} publicView />
              <div className="mt-10">
                <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-teal-600 text-white text-sm font-bold hover:bg-teal-700 transition-colors" data-testid="public-card-cta">
                  <Sparkles size={15} /> Build your own Career Clarity Card
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
